module.exports = __webpack_public_path__ + "img/CameraZOOM-20210712092523441.ce75f2c0.jpg";